import styled from 'styled-components';

export const NumbersInfoListStyled = styled.div`
  .box-wapper {
    height: 100%;
    padding: 0 6px 12px;
  }

  .updateTime {
    color: #666;
  }
  .divider {
    width: 1px;
    height: 57px;
  }
`;
